import listMixin from '@/components/niotaClassic/listMixin';
import listOptionsPersistenceMixin from '@/components/custom/listOptionsPersistenceMixin';
import overviewEditMixin from '@/components/core/dtwin/overviewEditMixin';
import multiSearchMixin from '@/mixins/multiSearchDigitalTwins';
import { localizeDate } from '@/utils/date';
import ApiService from '@/services/apiService';
import isEqual from 'lodash/isEqual';
import get from 'lodash/get';
const defaultItemsPerPage = 10;
const defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'ViewDigitalTwinDigitalTwinRulesMonitor',
  mixins: [listMixin, listOptionsPersistenceMixin, overviewEditMixin, multiSearchMixin],
  data: function () {
    return {
      list: [],
      isFetching: false,
      serverItemsLength: -1,
      listPersistencePath: 'DigitalTwin.rulesMonitor',
      searchMode: 'multi',
      favouriteMode: 'on',
      favouriteFilter: false,
      includeVDRules: false,
      lastSearch: '',
      tableOptions: defaultTableOptions,
      defaultTableOptions: {
        ...defaultTableOptions
      },
      disableFetchOnCreatedMixin: true,
      historyDialog: false,
      historyQueryStartDate: new Date(new Date() - 86400000 * 5),
      historyQueryEndDate: new Date(),
      executionHistoryRule: {},
      executionHistoryTableOptions: {},
      executionHistory: [],
      executionHistoryItemsLength: -1,
      executionHistoryTableHeaders: [{
        text: this.$i18n_t('Common.date'),
        value: 'date',
        sortable: false
      }, {
        text: this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.executionConditionResult'),
        value: 'conditionsResult',
        sortable: false
      }, {
        text: this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.executionConditionChanged'),
        value: 'changed',
        sortable: false
      }, {
        text: this.$i18n_t('BackgroundJobs.BackgroundJobs.errorMessage'),
        value: 'execErrors',
        sortable: false
      }, {
        text: '',
        value: 'data-table-expand'
      }],
      executionHistoryTableFooter: {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [15, 30, 50, 100]
      }
    };
  },
  computed: {
    tableLocalized() {
      return {
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
        },
        headers: [{
          sortable: false
        }, {
          sortable: true,
          text: this.$i18n_t('DigitalTwin.DigitalTwin.states.title'),
          value: 'title'
        }, {
          sortable: false
        }, {
          sortable: true,
          text: this.$i18n_t('Common.digitalTwins.searchLabel'),
          value: 'dtwin.title'
        }, {
          sortable: false
        }, {
          sortable: false,
          text: this.$i18n_t('DigitalTwin.DigitalTwin.ruleOverviewTable.lastErrornousExecution'),
          value: 'lastTrigger'
        }, {
          sortable: false,
          text: this.$i18n_t('DigitalTwin.DigitalTwin.ruleOverviewTable.lastErrormessage'),
          value: 'properties.actions'
        }]
      };
    }
  },
  watch: {
    executionHistoryTableOptions: {
      handler() {
        if (this.executionHistoryRule) {
          this.fetchRuleExecutionHistory(this.executionHistoryRule);
        }
      },
      deep: true
    }
  },
  methods: {
    get,
    localizeDate,
    breadCrumbsPath() {
      return [{
        to: '/digitaltwin-mgmt',
        text: this.$i18n_t('Common.drawer.dTwins')
      }, this.$i18n_t('Common.drawer.dTwinRulesMonitor')];
    },
    fetchList(fromStart = false) {
      if (this.isFetching) {
        return;
      }
      this.isFetching = true;
      const searchItems = this.searchItems.map(item => ({
        variable: item.param,
        // support item.search.value === null, so do not simply have a >search.value || search< expression
        search: (item.search || {}).value === undefined ? item.search : item.search.value,
        key: item.key
      }));
      if (!isEqual(this.lastSearch, JSON.stringify(searchItems))) {
        this.lastSearch = JSON.stringify(searchItems);
        this.tableOptions = {
          ...this.tableOptions,
          page: 1
        };
      }
      const tableOptions = fromStart ? {
        ...this.tableOptions,
        page: 1
      } : this.tableOptions;
      const {
        sortBy,
        sortDesc,
        page,
        itemsPerPage
      } = tableOptions;
      const sortItem = sortBy && sortBy.length ? sortBy[0] : 'id';
      const doSortDesc = sortDesc && sortDesc.length ? sortDesc[0] : false;
      const sortDirection = doSortDesc ? 'DESC' : 'ASC';
      const usedPage = page ? page - 1 : 0;
      const usedItemsPerPage = itemsPerPage || defaultItemsPerPage;
      const filters = [];
      const accountIds = this.selectedAccounts.map(a => a.id);
      if (accountIds.length) {
        filters.push({
          type: 'tenantIds',
          ids: accountIds
        });
      }

      // persist options for next call of this page (during this browser-tab-session)
      this.$store.state.app.pageFilters = {
        ...this.$store.state.app.pageFilters,
        DigitalTwin: {
          ...(get(this.$store.state.app, 'pageFilters.DigitalTwin') || {}),
          rulesMonitor: {
            searchDetails: this.searchItems,
            tableOptions,
            favouriteFilter: this.favouriteFilter || false
          }
        }
      };
      ApiService.digitalTwinFetchRulesWithErrornousExecutions(this, usedPage * usedItemsPerPage, usedItemsPerPage, {
        variable: sortItem,
        direction: sortDirection
      }, searchItems,
      // NOTE: not yet implemented on BE-side
      filters, this.favouriteFilter ? ['favourites'] : null, this.includeVDRules).then(res => {
        this.list = res.errorRules;
        this.serverItemsLength = res.totalCount;
      }).catch(error => {
        console.error('Error fetching twin-list', error);
      }).finally(() => {
        this.isFetching = false;
      });
    },
    updatePagination(e) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          ...{
            page: e.page || defaultTableOptions.page
          },
          ...{
            perPage: e.itemsPerPage || defaultTableOptions.itemsPerPage
          }
        }
      }).catch(error => {
        console.error(error);
      });
    },
    processedRuleActions(rule) {
      return (get(rule, 'properties.actions') || []).map(action => this.processRuleAction(action));
    },
    processRuleAction(action) {
      const commandParts = (get(action, 'command') || '').split('.');
      if (commandParts.length < 2) {
        return {};
      }
      const bridgeInstanceId = commandParts[0];
      const command = action.command.substring(bridgeInstanceId.length + 1);
      const triggerType = action.triggerType === 'CHANGES' ? this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.changes') : this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.evaluates');
      const bridgeInstance = this.bridgeInstances.find(b => b.id === parseInt(bridgeInstanceId));
      return {
        command: `${get(bridgeInstance, 'name') || 'Unknown'}.${command}`,
        condition: `${this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.ifCondition')} ${triggerType} ${this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.conditionTo')} ${action.triggerValue}`,
        lastExecution: action.lastExecution ? this.localizeDate(get(action, 'lastExecution.date') || null) : null
      };
    },
    baseDetailLink(item) {
      const basePath = item.dtwin.type === 'virtualDevice' ? 'virtual-devices' : 'digitaltwin-mgmt';
      return `/${basePath}/${item.dtwinId}`;
    },
    detailButtonClicked(item) {
      this.$router.push(`${this.baseDetailLink(item)}?ruleId=${item.id}`, '_blank');
    },
    openExecutionHistoryDialog(rule) {
      // for initial opening, set the execution-timeframe to within the latest errornous execution-date
      this.historyDialog = false;
      this.historyQueryEndDate = new Date(rule.errorExec.date);
      this.historyQueryStartDate = new Date(new Date(rule.errorExec.date) - 86400 * 1000 * 14);
      this.fetchRuleExecutionHistory(rule, true);
    },
    fetchRuleExecutionHistory(rule, resetTableOptions = false) {
      this.historyDialog = true;
      if (resetTableOptions) {
        this.executionHistoryRule = rule;
        // reset to page 1,
        this.executionHistoryTableOptions = {
          ...this.executionHistoryTableOptions,
          page: 1,
          itemsPerPage: 15
        };
        // above will trigger a call to fetchRuleExecutionHistory
        return;
      }
      const {
        page,
        itemsPerPage
      } = this.executionHistoryTableOptions;
      const usedPage = Math.max(1, page || 1);
      const usedItemsPerPage = itemsPerPage || 15;
      const offset = (usedPage - 1) * usedItemsPerPage;
      this.executionHistoryRule = rule;
      ApiService.digitalTwinFetchRuleExecutionHistory(this, rule.dtwinId, rule.id, this.historyQueryStartDate, this.historyQueryEndDate, ['errornousonly'], offset, usedItemsPerPage).then(history => {
        this.executionHistoryItemsLength = get(history, 'totalCount') || 0;
        this.executionHistory = get(history, 'executions') || [];
        this.historyDialog = true;
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(get(error, 'response.data.message', this.$i18n_t('Common.usersFetchFail')), 'error');
        }
      });
    },
    showExecutionHistoryExportDialog(rule) {
      this.executionHistoryRule = rule;
      this.executionHistoryExportDialog = true;
    },
    handleDatePicked(dateObject) {
      this.historyQueryStartDate = new Date(dateObject.from * 1000);
      this.historyQueryEndDate = new Date(dateObject.to * 1000);
      this.fetchRuleExecutionHistory(this.executionHistoryRule, true);
    }
  }
};